import { createFocusTrap, FocusTrap } from 'focus-trap';

function toggleNavMenu(trap: FocusTrap, animate: boolean) {
  const navMenu = document.querySelector('nav')!;
  const navButton = document.getElementById('nav-button')!;

  if (!animate) {
    document.documentElement.classList.add('no-transition');
  }
  navButton.classList.toggle('active');
  navMenu.classList.toggle('active');

  // TODO: Figure out how to translate these.
  const isActive = navButton.classList.contains('active');
  if (isActive) {
    navButton.setAttribute('aria-label', 'Close');
    trap.activate();
  } else {
    navButton.setAttribute('aria-label', 'Navigation Menu');
    trap.deactivate();
  }

  if (!animate) {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove('no-transition');
    });
  }
}

async function createMap() {
  const mapElement = document.querySelector(
    'gmp-map'
  ) as google.maps.MapElement;

  if (!mapElement) return;

  const [{ }, { AdvancedMarkerElement }] = await Promise.all([
    google.maps.importLibrary('maps') as Promise<google.maps.MapsLibrary>,
    google.maps.importLibrary(
      'marker'
    ) as Promise<google.maps.MarkerLibrary>,
  ]);

  const innerMap = mapElement.innerMap;

  const opts: google.maps.MapOptions = {
    center: {
      lat: 40.443755,
      lng: -79.883959,
    },
    zoom: 18,
    mapId: 'f5d6c0f564551fb8300d59b2',
    clickableIcons: false,
    disableDoubleClickZoom: false,
    draggable: true,
    keyboardShortcuts: false,
    scrollwheel: false,
    fullscreenControl: false,
    mapTypeControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    zoomControl: false,
  };
  innerMap.setOptions(opts);

  const marker = new AdvancedMarkerElement({
    map: innerMap,
    position: mapElement.center,
    title: 'International Museum of the Bamileke Genocode',
  });
  marker.addListener('gmp-click', () => {
    window.location.href = 'https://maps.app.goo.gl/Ay6XvtDbwLvJ1viZ9';
  })
}


async function initSlideshow() {
  const slideshow = document.querySelector('.slideshow');
  if (!slideshow) return;

  const images = Array.from(slideshow.querySelectorAll('.slideshow-image')) as HTMLImageElement[];
  if (images.length === 0) return;

  // Prefetch all images
  await Promise.all(images.map(img => {
    return new Promise((resolve) => {
      const tempImg = new Image();
      tempImg.onload = resolve;
      tempImg.onerror = resolve; // Continue even if some fail as per user request
      tempImg.src = img.src;
    });
  }));

  let currentIndex = 0;

  const showNextImage = () => {
    const currentImg = images[currentIndex];
    currentImg.classList.remove('active');
    currentImg.style.display = 'none';

    currentIndex = (currentIndex + 1) % images.length;

    const nextImg = images[currentIndex];
    nextImg.style.display = '';
    // Force reflow
    void nextImg.offsetWidth;
    nextImg.classList.add('active');
  };

  for (const img of images) {
    img.addEventListener('animationend', (e) => {
      // Ensure we only respond to the transform animation if there are others
      if (e.animationName === 'slideshowZoom') {
        showNextImage();
      }
    });
    img.addEventListener('click', () => showNextImage());
  }

  images[currentIndex].classList.add('active');
}

function initPage() {
  document.documentElement.classList.remove('no-transition');

  // Language selector
  document.getElementById('language-select')!.addEventListener('change', (event: Event) => {
    const language = (event.target! as HTMLSelectElement).value;
    if (language !== document.documentElement.lang) {
      const url = new URL(location.href);
      url.searchParams.set('lang', language);
      location.href = url.toString();
    }
  });
  // Make all local links keep the lang if set in the URL.
  const currentUrl = new URL(location.href);
  const currentLangParam = currentUrl.searchParams.get('lang');
  if (currentLangParam) {
    for (const link of Array.from(document.querySelectorAll('a'))) {
      if (link.getAttribute('href')?.startsWith('/')) {
        const linkUrl = new URL(link.href);
        linkUrl.searchParams.set('lang', currentLangParam);
        link.setAttribute('href', linkUrl.pathname + linkUrl.search + linkUrl.hash);
      }
    }
  }

  // Nav menu
  const navMenu = document.querySelector('nav')!;
  const trap = createFocusTrap([
    document.getElementById('nav-menu-controls')!,
    navMenu!
  ]);
  const navButton = document.getElementById('nav-button')!;
  navButton.addEventListener('click', () => {
    toggleNavMenu(trap, true /* animate */);
  });
  // Close the nav menu on history.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // This page was restored from the back-forward cache.
      if (navButton.classList.contains('active')) {
        toggleNavMenu(trap, false /* animate */);
      }
    }
  });

  // Animated transition.
  window.addEventListener('pageswap', (event) => {
    if (event.viewTransition) {
      const navType = event.activation?.navigationType;

      // 'traverse' indicates back/forward navigation
      if (navType === 'traverse') {
        event.viewTransition.skipTransition();
      }
    }
  });

  // Map for the pages that have it.
  createMap();

  // Slideshow
  initSlideshow();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPage);
} else {
  initPage();
}